<template>
  <v-toolbar flat>
    <v-toolbar-title style="overflow: visible !important">
      <img :class="['pt-2',$globalConfig.APP_NAME === 'senso' ? 'senso-partner-logo' : 'partner-logo']" :src="$globalConfig.APP_NAME === 'senso' ? '/static/login-logo.png' : '/static/logo-partner.png'" />
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <h4>{{ adminLevel }}</h4>
    <span style="text-align: right"> Email us: 
      <a href="mailto:support@senso.cloud" v-if="$globalConfig.APP_NAME === 'senso'">support@senso.cloud</a> 
      <a href="mailto:support@improve.online" v-else>support@improve.online</a> 
    </span>
    <v-btn v-if="isLoggedInByPartner" icon @click="signIntoPartner">
      <v-icon>fa-sign-in-alt</v-icon>
    </v-btn>
  </v-toolbar>
</template>
<script>
export default {
  name: 'Navigation',
  data: () => ({
    items: [{ title: 'Profile' }, { title: 'Logout' }],
  }),
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
    getTrialInfo: function () {
      return this.$store.getters.trialDays;
    },
    companyState: function () {
      const state = this.$store.getters.companyState;
      var text = '';
      switch (state) {
        case 1:
          text = 'Free Trial';
          break;
        case 2:
          text = 'Free Trial Expired';
          break;
        case 3:
          text = 'Active Membership';
          break;
        case 4:
          text = 'Membership Suspended';
          break;
        default:
          text = '';
      }
      return text;
    },
    adminLevel: function () {
      const level = this.$store.getters.level;
      var text = '';
      switch (level) {
        case 1:
          text = 'Super Administrator';
          break;
        case 2:
          return 'Administrator';
          break;
        case 4:
          return '';
          break;
        default:
          text = '';
          break;
      }
      return text;
    },
    isLoggedInByPartner: function () {
      if (
        localStorage.getItem('todos') != '' &&
        localStorage.getItem('todos') != null
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    // if (this.$store.getters.level == 4 || this.$store.getters.level == 5) {
    //   window.addEventListener
    //           ? window.addEventListener("load", this.initiateCall(), !1)
    //           : window.attachEvent("load", this.initiateCall(), !1);
    //   window.fcWidget.hide();
    // }
  },
  methods: {
    signIntoPartner: function () {
      this.$store
        .dispatch('autologin', {
          id: localStorage.getItem('todos'), //'lo9m8d5jd5e07yvx'
        })
        .then(() => {
          localStorage.setItem('todos', '');
          this.getProfile();
        })
        .catch((err) => {
          this.valid = false;
          this.loading = false;
          this.messages = [];
          let errors = err.response.data.errors;
          let errMsg = err.response.data.message;
          if (errMsg) {
            this.errorMessage = errMsg;
            this.$snotify.error(errMsg);
          }
          if (errors) {
            for (let field in errors) {
              this.messages[field] = errors[field];
            }
          }
        });
    },
    getProfile() {
      this.$store
        .dispatch('profile')
        .then((resp) => {
          switch (this.$store.getters.level) {
            case 2:
              this.$router.push('/admin');
              break;
            case 4:
              this.$router.push('/partner/users');
              break;
            default:
              this.$router.push('/');
              break;
          }
        })
        .catch((err) => {          
          this.loading = false;
        });
    },
    // showFreshChat() {
    //   this.openWidget();
    // },
    // initFreshChat() {
    //   window.fcWidget.init({
    //     token: "4c92e035-db9f-4403-985c-9170ed83bd69",
    //     host: "https://wchat.freshchat.com",
    //     externalId: this.$store.getters.user.id,
    //     firstName: this.$store.getters.user.first_name,
    //     lastName: this.$store.getters.user.last_name,
    //     config: {
    //       cssNames: {
    //         widget: "custom_fc_frame"
    //       }
    //     },
    //     faqTags : {
    //       // Array of Tags
    //       tags : ['hub'],
    //       //For articles, the below value should be article.
    //       //For article category, the below value should be category.
    //       filterType:'category' //Or filterType: 'article'
    //     }
    //   });
    //   window.fcWidget.hide();
    // },
    // initialize(i, t) {
    //   var e;
    //   i.getElementById(t)
    //           ? this.initFreshChat()
    //           : (((e = i.createElement("script")).id = t),
    //                   (e.async = !0),
    //                   (e.src = "https://wchat.freshchat.com/js/widget.js"),
    //                   (e.onload = this.initFreshChat),
    //                   i.head.appendChild(e));
    // },
    // initiateCall() {
    //   this.initialize(document, "freshchat-js-sdk");
    //   window.fcWidget.hide();
    // },
    // openWidget() {
    //   window.fcWidget.open();
    //   window.fcWidget.show();
    //   window.fcWidget.on("widget:closed", function (resp) {
    //     document.getElementById('fc_frame').className = 'custom_fc_frame fc-widget-normal hide';
    //   });
    // }
  },
};
</script>
